export default {

  // 用户的报名申请列表
  getJoinList(params, success) {
    Request.GET('/user/enrollment', params, response => success(response));
  },

  // 用户的报名申请详情
  getJoinDetail(id, success) {
    Request.GET(`/user/enrollment/${id}`, null, response => success(response));
  },

  // 查询用户信息
  getUserInfo(id, success) {
    Request.GET('/user/detail', null, response => success(response));
  },

  // 用户信息修改
  saveUserInfo(params, success) {
    Request.PUT('/user/detail', params, response => success(response));
  },

  // 操作：撤销or重新提交['cancel', 'submit']
  cancelJoinSubmit(id, params, success) {
    Request.PUT(`/user/enrollment/${id}`, params, response => success(response));
  },
};



// WEBPACK FOOTER //
// ./src/api/userInfoApi.js